import React from "react";
import {blue} from '../../styles';

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 512 512"
      fill={blue}
    >
      <path d="M497 120.5H361.375V90.692c0-33.397-27.171-60.567-60.567-60.567h-89.615c-33.396 0-60.567 27.17-60.567 60.567V120.5H15c-8.284 0-15 6.716-15 15V408c0 40.735 33.141 73.875 73.875 73.875h364.25c40.734 0 73.875-33.14 73.875-73.875V135.5c0-8.284-6.716-15-15-15zM290.035 316.25c0 18.767-15.269 34.035-34.035 34.035s-34.035-15.268-34.035-34.035v-34.035h68.07zm15-64.035h-98.07c-8.284 0-15 6.716-15 15v27.247C104.737 275.53 39.348 218.952 30.935 150.5h450.129c-8.413 68.452-73.801 125.03-161.029 143.963v-27.247c0-8.285-6.716-15.001-15-15.001zM180.625 90.692c0-16.855 13.713-30.567 30.567-30.567h89.615c16.854 0 30.567 13.712 30.567 30.567V120.5h-150.75V90.692zM482 408c0 24.193-19.683 43.875-43.875 43.875H73.875C49.683 451.875 30 432.193 30 408V227.854c12.11 17.317 27.724 33.308 46.587 47.455 32.687 24.515 72.592 41.535 116.022 49.932 4.386 31.065 31.134 55.043 63.391 55.043s59.005-23.978 63.391-55.043c43.43-8.397 83.334-25.417 116.022-49.932 18.863-14.147 34.477-30.139 46.587-47.455z"></path>
    </svg>
  );
}

export default Icon;